export const VALIDATION_API_PATHS = {
  NATIONAL_ID: '/membership/verify/id-number',
  TIN_NUMBER: '/public/members/verify/tin-number',
  PRE_APPROVAL: '/public/members/verify/pre-approval',
  DEED_DETAILS: '/restricted/transfer/validate/deed/details',
} as const;

export const DROPDOWN_API_PATHS = {
  ROLES: '/role/search',
  ROLE_SERVICE_CATEGORIES: '/role/service-category',
  OFFICES: '/restricted/office/all',
  PROVINCES: '/province/all',
  DISTRICTS_BY_PROVINCE: '/district/province' ,
  DISTRICTS: '/district/all',
  SERVICE_CATEGORIES: '/public/service-category/get/all',
  CURRENCIES: '/public/currency/search',
  LAW_FIRMS: '/public/members/get/law-firms',
} as const;
